import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { Hanko, register } from "@teamhanko/hanko-elements";
import styles from "./Todo.module.css";
import { useNavigate } from "react-router-dom";
import { SessionExpiredModal } from "./SessionExpiredModal";

const api = process.env.REACT_APP_HANKO_API!;

function HankoProfile() {
  const navigate = useNavigate();
  const [error, setError] = useState<Error | null>(null);
  const modalRef = useRef<HTMLDialogElement>(null);
  const hankoRef = useRef<Hanko | null>(null);

  const redirectToLogin = useCallback(() => {
    navigate("/");
  }, [navigate]);

  const logout = () => {
    hankoRef.current?.logout().catch(setError);
  };

  const redirectToTodo = () => {
    navigate("/todo");
  };

  useEffect(() => {
    register(api)
      .then(({ hanko }) => {
        hankoRef.current = hanko;
        hanko.validateSession().then((session) => {
          if (!session.is_valid) {
            redirectToLogin();
          }
        });
        hanko.onUserLoggedOut(() => redirectToLogin());
        hanko.onSessionExpired(() => modalRef.current?.showModal());
      })
      .catch(setError);
  }, [redirectToLogin]);

  return (
    <>
      <SessionExpiredModal ref={modalRef} />
      <nav className={styles.nav}>
        <button onClick={logout} className={styles.button}>
          Logout
        </button>
        <button disabled className={styles.button}>
          Profile
        </button>
        <button onClick={redirectToTodo} className={styles.button}>
          IP Address
        </button>
      </nav>
      <div className={styles.content}>
        <h1 className={styles.headline}>Profile</h1>
        <div className={styles.error}>{error?.message}</div>
        <hanko-profile />
      </div>
    </>
  );
}

export default HankoProfile;
